import React from 'react'
import PropTypes from 'prop-types'
import Text from '../../../components/text'
import Button from '../../../components/button'

const ChatConversationsTypeHeaderBtn = ({ title, tab, isActive, onClick }) => {
  const activeClass = isActive ? _s.borderColorBrand : undefined
  return (
    <Button
      noClasses
      onClick={() => onClick(tab)}
      className={[_s.d, _s.noUnderline, _s.py10, _s.pl15, _s.flex1, _s.bgTransparent, _s.noOutline, _s.cursorPointer, _s.borderBottom3PX, activeClass].join(' ')}
    >
      <Text color='secondary' weight='medium'>{title}</Text>
    </Button>
  )
}

const ChatConversationsTypeHeader = ({ activeTab, onClick }) => {
  return (
    <div
      className={[_s.d, _s.w100PC, _s.bgPrimary, _s.borderBottom1PX, _s.borderColorSecondary].join(' ')}
    >
      <div className={[_s.d, _s.flexRow].join(' ')}>
        <ChatConversationsTypeHeaderBtn title='ALL CHATS' tab='all' onClick={onClick} isActive={activeTab==='all'}/>
        <ChatConversationsTypeHeaderBtn title='GROUP CHATS' tab='group' onClick={onClick} isActive={activeTab==='group'}/>
      </div>
    </div>
  )
}

ChatConversationsTypeHeader.propTypes = {
  activeTab: PropTypes.string,
}

export default ChatConversationsTypeHeader